<section class="widget-page">
  <div class="d-flex align-items-center gap-3 mb-3">
    <div class="d-flex align-items-center gap-2">
      <h6 class="mb-0 page-title" i18n>Search Widget</h6>
      <app-page-help [articleId]="'ho9v2piyuh'" videoId="-"></app-page-help>
    </div>
    <div class="flex-fill"></div>
    <a routerLink="/widgets" class="btn btn-secondary-primary">
      <i class="far fa-chevron-left"></i> <ng-container i18n>Back to Widgets</ng-container>
    </a>
  </div>

  <div class="main-content">
    <div class="container-box details-box">
      <div class="box-body">
        <div class="row">
          <div class="col-lg-6 col-xl-5">
            <div class="widget-holder p-3">
              <div class="alert alert-secondary-info">
                <i class="cs-icon cs-icon-info-circle alert-icon"></i>
                <div class="aler-content" i18n>
                  First select the AdvanceCM website, then configure the widget as you like.
                </div>
              </div>

              <form [formGroup]="form">
                <div class="clearfix widget-box">
                  <h4 class="title">
                    <ng-container i18n>1. Select the AdvanceCM website</ng-container> <span class="red-star">*</span>
                    <app-info-icon
                      i18n-tooltipText
                      tooltipText="The Search Widget requires that you create a AdvanceCM website in order to present a results page that will guide the guest through the steps of selecting an available rental, sending an inquiry or confirming a booking. For options that do not involve re-directing the guest, please see the interstitial widget option."
                    ></app-info-icon>
                  </h4>
                  <div class="row">
                    <div class="col-sm-12">
                      <app-select-search
                        bindLabel="title"
                        [inline]="false"
                        [multiple]="false"
                        [items]="websites$ | async"
                        [ctrl]="form.get('website')"
                        i18n-placeholder
                        placeholder="Website"
                      ></app-select-search>
                    </div>
                  </div>
                </div>

                <!-- ***if want to disable/pointer-event:none for this section***
                  <div class="clearfix widget-box disabled"> -->

                <div class="clearfix widget-box">
                  <h4 class="title">
                    2. Widget Style
                    <app-info-icon
                      i18n-tooltipText
                      tooltipText="Your changes can be viewed in the widget preview to the right of this configuration menu."
                    ></app-info-icon>
                  </h4>
                  <div class="row">
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('background').value"
                          i18n-placeholder
                          placeholder="Widget Background"
                          [colorPicker]="form.get('background').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('background', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('background').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('button_bg').value"
                          i18n-placeholder
                          placeholder="Button Background"
                          [colorPicker]="form.get('button_bg').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('button_bg', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('button_bg').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('button_fg').value"
                          i18n-placeholder
                          placeholder="Button Text"
                          [colorPicker]="form.get('button_fg').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('button_fg', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('button_fg').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('label_bg').value"
                          i18n-placeholder
                          placeholder="Label Color"
                          [colorPicker]="form.get('label_bg').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('label_bg', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('label_bg').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('selected_bg').value"
                          i18n-placeholder
                          placeholder="Selected Dates"
                          [colorPicker]="form.get('selected_bg').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('selected_bg', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('selected_bg').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('selected_fg').value"
                          i18n-placeholder
                          placeholder="Selected Text"
                          [colorPicker]="form.get('selected_fg').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('selected_fg', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('selected_fg').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2>
                        <mat-select placeholder="Font Family" i18n-placeholder formControlName="font" required>
                          <mat-option *ngFor="let font of fontFamilies" [value]="font">
                            {{ font }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2>
                        <mat-select placeholder="Font Size" i18n-placeholder formControlName="label_px">
                          <mat-option *ngFor="let size of fontSizeOpts" [value]="size">
                            {{ size }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2>
                        <mat-select placeholder="Orientation" i18n-placeholder formControlName="orientation" required>
                          <mat-option *ngFor="let dir of orientationOpts" [value]="dir">
                            {{ dir }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          type="number"
                          matInput
                          required
                          i18n-placeholder
                          placeholder="Widget Width (px)"
                          formControlName="width"
                        />
                      </mat-form-field2>
                    </div>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <div class="alert alert-dark widget-code-wrapper">
                    <p i18n>Widget Code</p>
                    <div class="widget-code" [innerText]="widgetCode"></div>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <h4 class="title" i18n>3. Copy and paste the desired widget code onto your website.</h4>
                  <div class="row">
                    <div class="col-sm-12 btn-holder">
                      <button
                        type="button"
                        [disabled]="!widgetCode"
                        ngxClipboard
                        [cbContent]="widgetCode"
                        (cbOnSuccess)="onCopied($event)"
                        class="btn btn-secondary-light"
                      >
                        <span class="fal fa-copy"></span>
                        <ng-container i18n>copy code</ng-container>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-lg-6 col-xl-7">
            <div class="widget-preview d-flex align-items-center flex-column h-100 p-3">
              <h5 class="title text-light" i18n>Widget Preview</h5>

              <div
                class="preview-box flex-fill w-100"
                *ngIf="trustedWidgetCode"
                [style.height.px]="preview?.contentWindow?.document?.documentElement?.scrollHeight"
              >
                <iframe [srcdoc]="trustedWidgetCode" frameborder="0" class="w-100 h-100" #preview></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
